import {Settings} from 'app/common/Settings';

let gaCode;

export function googleAnalyticsHeadScripts(){
  if (!gaCode) {
    let environment = Settings.getEnvironment().toUpperCase();
    if (environment === "LIVE")
      gaCode = "UA-135188952-1";
    else if (environment === "STAGING")
      gaCode = "UA-135188952-2";  
  } 

  if (gaCode) {
    const head = document.getElementsByTagName('head')[0];
  
    const googleAnalyticsFirstScript = document.createElement('script');
    googleAnalyticsFirstScript.async = true;
    googleAnalyticsFirstScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + gaCode;
  
    const googleAnalyticsSecondScript = document.createElement('script');
    googleAnalyticsSecondScript.innerHTML = '    window.dataLayer = window.dataLayer || [];\n' +
      '    function gtag(){dataLayer.push(arguments);}\n' +
      '    gtag(\'js\', new Date());\n' +
      '\n' +
      '    gtag(\'config\', \'' + gaCode + '\');';
  
    head.insertBefore(googleAnalyticsSecondScript, head.firstChild);
    head.insertBefore(googleAnalyticsFirstScript, head.firstChild);
  }
}

export function googleAnalytics(url) {
  gtag('config', gaCode, {'page_path': url});
}